import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { PipesModule } from "../shared/pipes/pipes.module";
import { ComponentsModule } from '../shared/components/components.module';

import { TotalRoutingModule } from "./total-routing.module";
import { Saseung3Module } from "../saseung3/saseung3.module";

import { TotalComponent } from "./total.component";


@NgModule({
  declarations: [
    TotalComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    PipesModule,
    ComponentsModule,
    TotalRoutingModule,
    Saseung3Module,
  ],
  providers: [
  ],
  exports: [
    TotalComponent,
  ],
})
export class TotalModule {}
